<template>
  <div style="padding: 40px 0;">
    <div class="company-core-account">
      <h1 class="account-title">站内信</h1>
      <scroll-view :isLoading="isLoading" :isEnd="contents.page.pn * contents.page.ps >= contents.page.total" @reach-bottom="loadMoreContents">
        <div class="register-info" :style='{
          "opacity": item.is_read ? 0.4 : 1
        }' v-for="(item, idx) in contents.data" :key='idx'>
          <div class="l-1">
            <h2 class="title">{{ item.msg_title }}</h2>
            <h2 class="time">{{ renderTime(item.ctime) }}</h2>
          </div>
          <div class="p-1" v-html='item.msg_content'>
          </div>
        </div>
      </scroll-view>
    </div>
  </div>
</template>

<script>
import { login } from '@/utils/login'
import ScrollView from './scrollView'

export default {
  name: 'account',
  mounted () {
    if (this.$store.state.userInfo) {
      this.loadMoreContents()
      this.$LogReport.sendCustomEvent('openplat_message_page_load')
    } else {
      this.$router.push({
        name: 'home'
      })
      login()
    }
  },
  components: {
    ScrollView,
  },
  data() {
    return {
      contents: {
        data: [],
        page: {
          ps: 10,
          pn: 0,
          total: 0
        }
      },
      isLoading: false,
    }
  },
  methods: {
    async loadMoreContents () {
      this.isLoading = true
      const params = { ps: this.contents.page.ps, pn: this.contents.page.pn + 1 }
      const res = await this.$api.user.getMessageList(params)
      this.contents.data.push(...res.list)
      this.contents.page = res.page
      this.isLoading = false
    },
    renderTime(time) {
      if(time === '') return ''
      return window.moment.unix(time).format('YYYY-MM-DD HH:mm:ss')
    },
  }
}
</script>

<style scoped lang="scss">
.company-core-account {
  min-width: 960px;
  width: 100%;
  max-width: 1168px;
  margin: 0 auto;
  box-sizing: border-box;
  border: 1px solid #e7e7e7;

  .account-title {
    padding: 20px 26px;
    box-shadow: inset 0 -1px 0 0 #e7e7e7;
    font-size: 24px;
    color: #212121;
  }

  .register-info {
    padding: 15px 26px 35px;
    .l-1 {
      display: flex;
      align-items: center;
      .title {
        flex: 1;
        padding: 16px 35px;
        font-size: 18px;
        color: #222222;
      }
      .time {
        font-size: 14px;
      }
    }
    .p-1 {
      padding: 0 35px 0;
      font-size: 14px;
    }
    .info-label {
      
      font-size: 14px;
      color: #505050;
      line-height: 22px;

      .info-label-key {
        width: 180px;
        display: inline-block;
      }
    }
  }
}
</style>
